import { request2 } from "./request.js";


// 获取年份下相关的班级id
export function GetNowYearGradeIds(data) {
    return request2({
        url: '/api2/TZsbWebTeachApi/Home/GetNowYearGradeIds',
        method: 'get',
        params: data
    });
}

// 获取班级最近一次作业统计信息
export function GetLatestWorkStatistics(data) {
    return request2({
        url: '/api2/TZsbWebTeachApi/Home/GetLatestWorkStatistics',
        method: 'post',
        data
    });
}

// 获取积分统计信息
export function GetIntegralStatistics(data) {
    return request2({
        url: '/api2/TZsbWebTeachApi/Home/GetIntegralStatistics',
        method: 'post',
        data
    });
}

// 获取出勤统计信息
export function GetAttendanceStatistics(data,nowTime) {
    return request2({
        url: '/api2/TZsbWebTeachApi/Home/GetAttendanceStatistics?nowTime='+nowTime,
        method: 'post',
        data
    });
}

// 获取天气信息
export function GetWeatherMessage(data) {
    return request2({
        url: '/api2/TZsbWebTeachApi/Home/GetWeatherMessage',
        method: 'post',
        data
    });
}

// 获取当年的班级考试信息、线下考试统计、线下考试平均分(三合一)
export function GetOfflineExaminationAverageScores(data,yearId) {
    return request2({
        url: `/api2/TZsbWebProductApi/Examination/GetOfflineExaminationAverageScores?yearId=${yearId}`,
        method: 'post',
        data: data
    });
}

// 获取学习单词统计
export function GetGradeStudyRankAsync(data,nowTime) {
    return request2({
        url: '/api2/TZsbWordWebApi0714hhwd/WordWeb/GetGradeStudyRank?nowTime='+nowTime,
        method: 'post',
        data
    });
}

// 获取单词练习统计
export function GetPracticeStatistics(data) {
    return request2({
        url: '/api2/TZsbWordWebApi0714hhwd/Statistics/GetPracticeStatistics',
        method: 'post',
        data
    });
}